












































import { Component, Vue, Prop, Inject } from 'vue-property-decorator'
import { productLinkUrl } from '@core/utils/jump'
import { isRkhy, getAppointDate, isTCQZMiniprogram, cookies } from '@/app/core/utils'
import iconUserGold from '@/assets/images/search/icon-user_gold2.png'
import iconUserPregnant from '@/assets/images/search/icon-user_pregnant2.png'
import iconUserCertify from '@/assets/images/search/icon-user_certify2.png'

@Component({
  filters: {
    distanceStr(distance: string) {
      return +distance > 60 ? '>60' : distance
    }
  }
})
export default class BusinessItem extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any
  @Prop({ default: 1 }) readonly type!: number //1表示普通 搜索列表样式  2表示卡片 城市站样式

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200005')
  clickid_200005!: string
  @Inject({ from: 'clickid_home_product', default: '' })
  clickid_home_product!: string

  tcqzUerLevel = 0 //同城亲子小程序合伙人等级

  mounted() {
    isTCQZMiniprogram().then(res => {
      if (res) {
        this.tcqzUerLevel = cookies.get('dfwUserLevel')
      }
    })
  }

  get goDetail() {
    return productLinkUrl(this.value.linkUrl, this.type === 1 ? 3 : 5)
  }
  get goDetailExposure() {
    return `${this.clickid_home_product || this.clickid_200005}||${JSON.stringify({ spuid: this.value.spuId, name: this.value.spuName })}`
  }
  goDetailClick() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_home_product || this.clickid_200005, positionParam: { spuid: this.value.spuId, name: this.value.spuName } })
  }
  getMaxShareEarnMoney() {
    if (this.tcqzUerLevel > 0) {
      if (this.tcqzUerLevel == 1) {
        return this.value.commonMaxCommission || 0
      } else if (this.tcqzUerLevel == 2) {
        return this.value.superMaxCommission || 0
      }
    }
    const ratio = JSON.parse(this.value.ratio)
    if (ratio && ratio.maxShareAmount) {
      return ratio.maxShareAmount
    }
    return 0
  }

  getMinShareEarnMoney() {
    if (this.tcqzUerLevel > 0) {
      if (this.tcqzUerLevel == 1) {
        return this.value.commonMinCommission || 0
      } else if (this.tcqzUerLevel == 2) {
        return this.value.superMinCommission || 0
      }
    }
    return JSON.parse(this.value.ratio).minShareAmount
  }
  //标签 1营销标签 promotion1 接口约定只有一个  2普通标签 promotion2 最多4个
  get promotionTag() {
    return (type: number) => {
      const { promotion1 = [], promotion2 = [] } = JSON.parse(this.value.promotions)
      if (type === 1) {
        const [p = ''] = promotion1
        return p
      } else {
        //spuSpotEndTime> 0 可订今日票
        const result = getAppointDate(this.value.reserveDate, this.value.reserveTime, this.value.spuSpotEndTime)
        if (result) return [...promotion2, result]
        return promotion2
      }
      return ''
    }
  }

  get spuUserTag() {
    if (this.value.customerType == 1) {
      return iconUserGold
    } else if (this.value.customerType == 2) {
      return iconUserPregnant
    } else if (this.value.customerType == 3) {
      return iconUserCertify
    }
    return ''
  }

  get isRKHYAPP() {
    return isRkhy()
  }
}
